import { combineReducers } from '@reduxjs/toolkit';
import user from './UserSlice';


const AuthReducers = combineReducers({
  user,
});

export default AuthReducers;